import { GetUsersPayload } from 'modules/roles-manager/domain/resources/role-users';
import { useGetRoleUsersQuery } from 'modules/roles-manager/store';

export interface UseRoleUsersParams {
  tournamentId?: number;
  page: number;
  perPage: number;
  filters?: Omit<GetUsersPayload, 'limit' | 'offset'>;
}

/** Страница пользователей организации (RTK Query, `roles-manager/store/role-users-api.ts`). */
export function useRoleUsers({ tournamentId, page, perPage, filters }: UseRoleUsersParams) {
  const offset = Math.max(0, (page - 1) * (perPage || 1));

  return useGetRoleUsersQuery({ organizerId: tournamentId as number, limit: perPage, offset, filters }, { skip: !tournamentId });
}

export default useRoleUsers;
